import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { FlutterBridgeService } from '../../services/flutter-bridge.service';

@Component({
  selector: 'app-callback',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './callback.component.html',
  styleUrl: './callback.component.scss'
})
export class CallbackComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  private readonly flutterBridge = inject(FlutterBridgeService);

  readonly isProcessing = signal<boolean>(true);
  readonly error = signal<string | null>(null);

  ngOnInit(): void {
    this.route.queryParams.subscribe(async (params) => {
      const sessionId = params['id'];

      if (!sessionId) {
        this.error.set('Session ID is missing');
        this.isProcessing.set(false);
        return;
      }

      try {
        const dataToSend = { sessionId: sessionId };
        this.flutterBridge.savePendingData(dataToSend);

        const success = await this.flutterBridge.sendDataToFlutterWithWait(dataToSend);

        if (success) {
          this.isProcessing.set(false);
          this.flutterBridge.clearPendingData();
        } else {
          this.error.set('Failed to send data to Flutter: bridge unavailable');
          this.isProcessing.set(false);
        }
      } catch (err) {
        this.error.set('Error processing callback');
        this.isProcessing.set(false);
        console.error('Callback processing error:', err);
      }
    });
  }
}

